// extracted by mini-css-extract-plugin
export default {"stepIcon":"stepper_stepIcon__2+YqE"};